import React from 'react';
import { motion } from 'framer-motion';

/**
 * Strip above a management page. The page's name lives in the banner at the
 * top of the app, so this carries only the description and any actions.
 * @param {string} subtitle - Description text
 * @param {React.ReactNode} actions - Optional action buttons on the right
 */
const PageHeader = ({ subtitle, actions }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-4"
    >
      <div className="flex justify-between items-center gap-4">
        {subtitle && <p className="text-gray-600">{subtitle}</p>}
        {actions && <div className="flex items-center gap-3 ml-auto">{actions}</div>}
      </div>
    </motion.div>
  );
};

export default PageHeader;
